import React from "react";
import { useFormContext } from "react-hook-form";
import { Grid } from "@mui/material";
import { SizingWrapperStyle } from "@/components/Wrapper";
import { CSectionPaper } from "@/components/AcquireBook/CSectionPaper";
import { ButtonVariantOption, SubmitButton } from "@/components/Button";
import {
  type PictureTypeData,
  type AcquireBookPictures,
  type BaseAcquireBookFormData,
  type ReuseUiData,
  type PictureTypeKey,
} from "@/types/acquirebook";
import { toast } from "react-toastify";
import { Label } from "@/components/Label";
import { CheckboxesToSelectBookOptions } from "./CheckboxesToSelectBookOptions";
import { ReuseInfoGetTimeoutMessage } from "@/hooks/useReuseInfoGetMutation";

interface IAcquireBookSelectionSectionProps {
  disabled: boolean;
  label?: string;
  disabledReuseRequestButton: boolean;
  isDataFetched: boolean;
  onClickReuseInfoGetButton: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    cancelLoading: () => void
  ) => void;
  getReuseData: (
    key: AcquireBookPictures,
    requestOptions: PictureTypeData
  ) => ReuseUiData;
  handleCustomOptionChange?: (event: boolean, key: PictureTypeKey) => void; // 図面チェックボックスを更新した場合に実行されるコールバック関数
}

/**
 * 登記/図面選択セクション
 * @param props
 */
export const AcquireBookSelectionSection: React.FC<
  IAcquireBookSelectionSectionProps
> = ({
  disabled,
  label = "取得したい登記/図面を選択してください",
  disabledReuseRequestButton,
  isDataFetched,
  onClickReuseInfoGetButton,
  getReuseData,
  handleCustomOptionChange,
}: IAcquireBookSelectionSectionProps) => {
  const reactHookForm = useFormContext<BaseAcquireBookFormData>();
  return (
    <>
      <Label required={!disabled}>{label}</Label>
      <CSectionPaper control={reactHookForm.control} name="pictureCheckOptions">
        <Grid
          container
          spacing={1}
          direction="row"
          sx={{
            justifyContent: "flex-start",
            alignItems: "flex-start",
            mx: 1,
            mt: 1,
            mb: 2,
          }}
        >
          <Grid item my={1} mr={1}>
            <SubmitButton
              label={"取得済・リユース登記/図面を確認する"}
              disabled={disabledReuseRequestButton}
              variant={ButtonVariantOption.Outlined}
              timeout={10000} // いったん10秒で設定
              size={SizingWrapperStyle.LARGE}
              onClick={onClickReuseInfoGetButton}
              onTimeout={() => {
                toast.info(ReuseInfoGetTimeoutMessage);
              }}
            />
          </Grid>
        </Grid>
        <CheckboxesToSelectBookOptions
          disabled={disabled}
          isDataFetched={isDataFetched}
          getReuseData={getReuseData}
          handleCustomOptionChange={handleCustomOptionChange}
        />
      </CSectionPaper>
    </>
  );
};
